import { CheckCircle2, Clock3 } from "lucide-react";
import type { FeedbackStatus } from "../../../api";

type FeedbackStatusBadgeProps = {
  status: FeedbackStatus;
};

export function FeedbackStatusBadge({ status }: FeedbackStatusBadgeProps) {
  const isResolved = status === "resolved";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${
        isResolved
          ? "bg-green-50 text-green-700 ring-1 ring-green-200"
          : "bg-amber-50 text-amber-700 ring-1 ring-amber-200"
      }`}
    >
      {isResolved ? <CheckCircle2 size={12} /> : <Clock3 size={12} />}
      {isResolved ? "Resolved" : "Open"}
    </span>
  );
}
